var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKrBackupActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24px/Active/Dark/KR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-41-Copy-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, -0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L17.7284036,10.0343424 C16.8729934,7.0133337 14.0949726,4.8 10.8,4.8 C6.8235498,4.8 3.6,8.0235498 3.6,12 C3.6,13.4607368 4.03499797,14.8198744 4.78252091,15.9549397 L9.79009169,24 L0,24 L0,0 L24,0 Z M11.3142857,8.4 C12.8571429,8.4 13.9371429,9.48 13.9371429,10.8685714 C13.9371429,12.4114286 12.7028571,12.9771429 12.7028571,12.9771429 L14.1942857,15.6 L12.1371429,15.6 L10.8273257,13.3371429 L9.87428571,13.3371429 L9.87428571,15.6 L7.92,15.6 L7.92,8.4 L11.3142857,8.4 Z M11.2114286,10.1485714 L9.87428571,10.1485714 L9.87428571,11.5885714 L11.2114286,11.5885714 C11.6742857,11.5885714 11.9828571,11.28 11.9828571,10.8685714 C11.9828571,10.4571429 11.6742857,10.1485714 11.2114286,10.1485714 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-2",
    transform: "translate(7.920000, 8.400000)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M17.7275145,13.968795 L24,24 L9.79009169,24 L4.79454005,15.9731301 C6.08367588,17.9177745 8.29209804,19.2 10.8,19.2 C14.0938318,19.2 16.8710698,16.9881986 17.7275145,13.968795 Z",
    id: "Path",
    fill: "#F0F2F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrBackupActive);
export default __webpack_public_path__ + "static/media/kr-backup-active.9107f932ec53d4423169077ba0228964.svg";
export { ForwardRef as ReactComponent };